import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslateLoaderService implements TranslateLoader {

  public static readonly langs = ['es', 'it'];
  private readonly url = './assets/i18n';
  // private readonly url = '/src/assets/i18n';

  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) { 

  }

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`${this.url}/${lang}.json`);
  }

  // init() {
  //   this.translateService.addLangs(TranslateLoaderService.langs);
  //   this.translateService.setDefaultLang(environment.lang);

  //   if (environment.langSource === "web") {
  //     const userLang = this.translateService.getBrowserLang() || navigator.language;
  //     if (userLang && TranslateLoaderService.langs.includes(userLang)) this.translateService.setDefaultLang(userLang);
  //   }
  // }
}

